var _excluded = ["children", "className"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["children", "className"],
  _excluded4 = ["children", "className"],
  _excluded5 = ["classNames", "className", "zIndex", "tipProps", "visible", "theme", "onVisibilityChange", "isAdaptive", "mediaString", "hideCloseButton", "size", "onCloseClick", "reference", "content", "renderContent", "placement", "isWithoutWrapper", "portalTarget", "children", "noPortal", "isClosedOnOutsideClick", "onMatchMediaChange", "isCenterAlignmentOnAdaptive", "renderWhenNotVisible", "as"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable custom-rules/need-data-qa */
/* eslint-disable custom-rules/delete-default-props */
import * as React from "react";
import { useEffect } from "react";
import Tip from "@components/tip";
import Popup from "@components/popup";
import { useMatchMedia } from "@ati/hooks";
import { joinCn, zIndexSystem } from "@ati/uti";
import styles from "./Popover.module.scss";
var PopoverContext = React.createContext({});
var zIndexDefault = {
  mainWrapper: zIndexSystem.abovePopover,
  // glz-z-above-popover
  closeButton: zIndexSystem.aboveContent,
  tip: zIndexSystem.popover // glz-z-popover
};

var defaultTipProps = {};
var defaultClassNames = {};
var Header = _ref => {
  var {
      children,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var ctx = React.useContext(PopoverContext);
  return ctx.isDesktop ? /*#__PURE__*/React.createElement("h4", _extends({
    className: joinCn(styles.header, className)
  }, rest), children) : /*#__PURE__*/React.createElement(Popup.Header, _extends({
    className: className
  }, rest), children);
};
var Content = _ref2 => {
  var {
      children,
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var ctx = React.useContext(PopoverContext);
  return ctx.isDesktop ? /*#__PURE__*/React.createElement("div", _extends({
    className: joinCn(styles.content, className)
  }, rest), children) : /*#__PURE__*/React.createElement(Popup.Content, _extends({
    className: className
  }, rest), children);
};
var Footer = _ref3 => {
  var {
      children,
      className
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var ctx = React.useContext(PopoverContext);
  return ctx.isDesktop ? /*#__PURE__*/React.createElement("div", _extends({
    className: joinCn(styles.footer, className)
  }, rest), children) : /*#__PURE__*/React.createElement(Popup.Footer, _extends({
    className: joinCn(styles["mobile-footer"], className)
  }, rest), children);
};
var ActionWrapper = _ref4 => {
  var {
      children,
      className
    } = _ref4,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  var ctx = React.useContext(PopoverContext);
  return ctx.isDesktop ? /*#__PURE__*/React.createElement("div", _extends({
    className: joinCn(styles.action, className)
  }, rest), children) : /*#__PURE__*/React.createElement(Popup.ActionWrapper, _extends({
    className: className
  }, rest), children);
};
var Popover = _ref5 => {
  var {
      classNames = defaultClassNames,
      className,
      zIndex,
      tipProps = defaultTipProps,
      visible,
      theme = "light",
      onVisibilityChange,
      isAdaptive = true,
      mediaString = "(max-width: 480px)",
      hideCloseButton,
      size = "medium",
      onCloseClick,
      reference,
      content,
      renderContent,
      placement = "top",
      isWithoutWrapper = false,
      portalTarget,
      children,
      noPortal,
      isClosedOnOutsideClick,
      onMatchMediaChange,
      isCenterAlignmentOnAdaptive,
      renderWhenNotVisible = true,
      as = "span"
    } = _ref5,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  var matchMedia = useMatchMedia(mediaString, onMatchMediaChange);
  var currentZIndex = _objectSpread(_objectSpread({}, zIndexDefault), zIndex);
  useEffect(() => {
    if (isAdaptive && onMatchMediaChange) {
      onMatchMediaChange(matchMedia);
    }
  }, []);
  var isContentVisible = renderWhenNotVisible || visible || !onVisibilityChange;
  var MainWrapper = () => /*#__PURE__*/React.createElement("div", _extends({
    style: {
      zIndex: currentZIndex.mainWrapper
    },
    className: joinCn(styles.wrapper, size !== "no-size" && (!matchMedia || !isAdaptive) && styles[size], styles["theme-".concat(theme)], classNames.contentWrapper, className)
  }, rest), isContentVisible && /*#__PURE__*/React.createElement(React.Fragment, null, !hideCloseButton && /*#__PURE__*/React.createElement("button", {
    style: {
      zIndex: currentZIndex.closeButton
    },
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    type: "button",
    className: joinCn(styles["close-button"], size !== "no-size" && (!matchMedia || !isAdaptive) && styles[size], classNames.closeButton),
    onClick: onCloseClick
  }), content == null && renderContent != null ? renderContent() : content));
  var isDesktop = noPortal || !isAdaptive || isAdaptive && !matchMedia || !visible;
  return /*#__PURE__*/React.createElement(Tip, _extends({
    duration: matchMedia && isAdaptive ? 0 : [300, 250]
  }, tipProps, {
    reference: reference,
    placement: placement,
    visible: visible,
    theme: theme,
    zIndex: currentZIndex,
    isWithoutWrapper: isWithoutWrapper,
    as: as,
    classNames: {
      tip: styles.tip,
      wrapper: classNames.childrenWrapper
    },
    onClickOutside: isClosedOnOutsideClick && onVisibilityChange && !(isAdaptive && matchMedia) ? () => onVisibilityChange(false) : () => {},
    content: /*#__PURE__*/React.createElement(PopoverContext.Provider, {
      value: {
        isDesktop
      }
    }, isDesktop ? /*#__PURE__*/React.createElement(MainWrapper, null) : /*#__PURE__*/React.createElement(Popup, {
      className: joinCn(matchMedia && isCenterAlignmentOnAdaptive && styles["is-center-alignment"]),
      onClose: onCloseClick,
      portalTarget: portalTarget
    }, content == null && renderContent != null ? renderContent() : content))
  }), children);
};
Popover.useSingleton = Tip.useSingleton;
Popover.Header = Header;
Popover.Content = Content;
Popover.Footer = Footer;
Popover.ActionWrapper = ActionWrapper;
export default Popover;